export default {
    password(newPassword) {
      const hasUpperCase = /[A-Z]/.test(newPassword);
      const hasLowerCase = /[a-z]/.test(newPassword);
      const hasNumber = /\d/.test(newPassword);
      const onlyLatin = /^[A-Za-z\d]+$/.test(newPassword);
      const minLength = 6;

      if (newPassword.length < minLength) {
        this.passwordIsValid = false;
        this.passwordErrorMessage =
          "Password should be at least 6 characters long";
        return;
      }

      if (!onlyLatin) {
        this.passwordIsValid = false;
        this.passwordErrorMessage =
          "Password should contain only Latin letters and numbers";
        return;
      }

      const missingRequirements = [];

      if (!hasUpperCase) missingRequirements.push("one uppercase letter");
      if (!hasLowerCase) missingRequirements.push("one lowercase letter");
      if (!hasNumber) missingRequirements.push("one number");

      if (missingRequirements.length > 0) {
        this.passwordIsValid = false;
        this.passwordErrorMessage = `Password should contain at least ${missingRequirements.join(
          ", "
        )}`;
      } else {
        this.passwordIsValid = true;
        this.passwordErrorMessage = "";
      }
    },

    email(newEmail) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(newEmail)) {
        this.emailIsValid = false;
        this.emailErrorMessage = "Enter the correct email";
      } 
      else {
        this.emailIsValid = true;
        this.emailErrorMessage = "";
      }
    }
}